import { post, get } from '../axios'

// collection列表
export function collection_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_COLLECTION}/collection/list`,
    map,
    option
  ).then(response => response)
}

// 配置设置
export function config_set_post(map, option) {
  return post(`${process.env.VUE_APP_CONFIG}/config/set`, map, option).then(
    response => response
  )
}

// 站点列表（组合id）
export function site_list_get(map, option) {
  return get(`${process.env.VUE_APP_SITE}/site/list`, map, option).then(
    response => response
  )
}

// 获取用户群列表
export function userGroup_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_USERGROUP}/userGroup/list`,
    map,
    option
  ).then(response => response)
}
